import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  Identifiable,
  Planzone,
  PlanzoneSettings,
  WbsConfiguration,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  configuration: WbsConfiguration;
  retrieveWbsConfiguration(
    req: Boundaries["retrieveWbsConfiguration"]["request"],
  ): void;
}

function useRetrieveWbsConfiguration(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveWbsConfigurationRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveWbsConfigurationRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveWbsConfigurationRequestFailure(planzone),
    ),
    configuration: useSelector(() => selector.getWbsConfiguration(planzone)),
    retrieveWbsConfiguration: core.retrieveWbsConfiguration,
  };
}

export { useRetrieveWbsConfiguration };
